const POST_LOGIN_REDIRECT_KEY = "postLoginRedirect";

export function rememberPostLoginRedirect(path: string): void {
	try {
		if (path && path.startsWith("/")) {
			sessionStorage.setItem(POST_LOGIN_REDIRECT_KEY, path);
		}
	} catch (error) {
		console.warn("Failed to remember post-login redirect", error);
	}
}

export function consumePostLoginRedirect(fallback = "/dashboard"): string {
	try {
		const redirect = sessionStorage.getItem(POST_LOGIN_REDIRECT_KEY);
		sessionStorage.removeItem(POST_LOGIN_REDIRECT_KEY);
		if (redirect && redirect.startsWith("/")) {
			return redirect;
		}
	} catch (error) {
		console.warn("Failed to consume post-login redirect", error);
	}
	return fallback;
}
